import Axios from "axios";

class LoginService {

  async doLogin(code) {
    const response = await Axios.get(
      'https://186bburdi6.execute-api.us-east-1.amazonaws.com/dev/auth?code=' + code,
      { headers: { 'Content-Type': 'application/json' } }
    )
    return response.data;
  }
}
export default LoginService;
